module.exports = __webpack_public_path__ + "static/media/tab-dashboard.07203a95.svg";